"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FluidGridLayout = void 0;
var FluidGridLayout = /** @class */ (function () {
    function FluidGridLayout() {
    }
    FluidGridLayout.prototype.createLayoutPassContext = function (options, availableSize, itemCount) {
        return { options: options, availableSize: availableSize, itemCount: itemCount };
    };
    FluidGridLayout.prototype.getItemSize = function (context) {
        var options = context.options, availableSize = context.availableSize;
        var actualAvailableWidth = availableSize.width - (options.columnCount - 1) * options.gutter;
        var width = actualAvailableWidth / options.columnCount;
        return {
            width: width,
            height: width * options.cellRatio,
        };
    };
    FluidGridLayout.prototype.getFullContentSize = function (context) {
        var options = context.options, itemCount = context.itemCount;
        var itemSize = this.getItemSize(context);
        var rowCount = Math.ceil(itemCount / options.columnCount);
        return {
            width: undefined, // TODO: what?
            height: (itemSize.height + options.gutter) * rowCount - options.gutter,
        };
    };
    FluidGridLayout.prototype.getItemRectAtIndex = function (context, index) {
        var options = context.options;
        var rowIndex = Math.floor(index / options.columnCount);
        var colIndex = index % options.columnCount;
        var itemSize = this.getItemSize(context);
        var itemOffsetX = colIndex * options.gutter;
        var itemOffsetY = rowIndex * options.gutter;
        return __assign({ x: colIndex * itemSize.width + itemOffsetX, y: rowIndex * itemSize.height + itemOffsetY }, itemSize);
    };
    FluidGridLayout.prototype.getItemRangeForRect = function (context, rect) {
        var options = context.options;
        var itemSize = this.getItemSize(context);
        var startRow = Math.floor((rect.y + options.gutter) / (itemSize.height + options.gutter));
        var startRowY = Math.floor((itemSize.height + options.gutter) * startRow);
        var rowStartDifference = rect.y - startRowY;
        var rowCount = Math.ceil((rect.height + options.gutter + rowStartDifference) / (itemSize.height + options.gutter));
        var startIndex = startRow * options.columnCount;
        var endIndex = startIndex + rowCount * options.columnCount;
        return {
            start: startIndex,
            end: endIndex,
        };
    };
    return FluidGridLayout;
}());
exports.FluidGridLayout = FluidGridLayout;
//# sourceMappingURL=FluidGridLayout.js.map